import { createSelector } from 'reselect';
import { getOnBoardingSelector } from 'store/selectors/onBoarding';
import { getSignUpRoleSelector } from 'store/selectors/loginGroup';

export const getOnBoardingData = createSelector(
  [getOnBoardingSelector, getSignUpRoleSelector],
  (onBoarding, signUpRole) => ({ onBoarding, signUpRole }),
);
